/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import "./CheckBoxstep1.scss";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { actionCreators } from "../../../store";
import { RootState } from "../../../store/reducers";
import { apiService } from "../../../services";
import { get_lang } from "../../../helper/getLang";
import FreezScreen from "../../../components/FreezScreen";
import CategoryBanner from "../../../components/CategoryBanner/CategoryBanners";
import GuestSlots from "../../../saas/styles/components/guestSlots/GuestSlots";
import PackageSlots from "../../../saas/styles/components/packageSlots/PackageSlots";
import GuestSlotsNew from "./components/GuestSlotsNew";
import PackageSlotsNew from "./components/PackageSlotsNew";
import RestaurantMenuIcon from "@material-ui/icons/RestaurantMenu";
import Steper from "../../../components/steper/Steper";
import { useTranslation, withTranslation } from "react-i18next";
import moment from "moment";
import dayjs from "dayjs";
import { Button } from "@material-ui/core";
import CategoryPills from "./components/CategoryPills";
import { shouldUseNewStep1Ui } from "./step1UiConfig";

const CheckBoxstep1 = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  bindActionCreators(actionCreators, dispatch);

  const navigate = useNavigate();
  const { search } = useLocation();
  const { slug } = useParams();
  const useNewUi = shouldUseNewStep1Ui(slug);

  const state = useSelector((state: RootState) => state.appReducer);
  const { langValue } = state;
  const appState = useSelector((state: RootState) => state.apiReducer);
  const { bookingDetails } = appState;

  const searchParams = new URLSearchParams(search);
  const [bId, setBId] = useState(searchParams.get("bId"));
  const [value, setValue] = useState(0);
  const [slotsType, setSlotsType] = useState(0);
  const [times, setTimes] = useState([]);
  const [slotsList, setSlotsList] = useState<any>([]);
  const [routeLoading, setRouteLoading] = useState(false);
  const [hasExtras, setHasExtras] = useState(false);
  const [initialMount, setInitialMount] = useState(true);
  const [apiLoading, setApiLoading] = useState(false);
  const [getSeletedDateByUSer, setGetSeletedDateByUSer] = useState<any>(null);
  const [excludedDates, setEXcludedDates] = useState(null);
  const handleGoBack = () => navigate(`/${slug}`);
  const [menu, setMenu] = useState(null);
  const [maxDays, setMaxDays] = useState(0);

  const slotProps = {
    slotsList,
    times,
    apiLoading,
    excludedDates,
    setGetSeletedDateByUSer,
    maxDays,
  };

  const handleClickTabs = (id: string) => {
    navigate(`/${slug}/step-1?bId=${id}`);
    setInitialMount(true);
    setBId(id);
    setGetSeletedDateByUSer(null);
  };

  const formatDateForApi = (date: any) => {
    return dayjs(date).format("DD-MM-YYYY");
  };

  const getBookingTime = async (
    bookingId: number | string,
    userDate: any = null
  ) => {
    const formattedDate = formatDateForApi(userDate);

    try {
      const res = await apiService.getSlotsTime(bookingId, formattedDate);
      if (res.data.success) {
        const currentDate = moment().format("DD-MM-YYYY");
        const userSelectedDate = userDate ? formattedDate : null;
        const currentTime = moment();
        const filteredTimes = res.data?.data
          ?.filter((item: any) => item?.active)
          .map((item: any) => {
            const startTime = moment(item.starting, "HH:mm");
            const endTime = moment(item.ending, "HH:mm");
            let isTimeAvailable = true;

            if (userSelectedDate === currentDate) {
              isTimeAvailable = currentTime.isBetween(startTime, endTime);
            }

            return { ...item, available_time: isTimeAvailable };
          });

        setTimes(filteredTimes);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getSlots = (bookingId: number | string) => {
    setApiLoading(true);
    try {
      const res = bookingDetails.find((item: any) => item?.id == bookingId);
      setSlotsList([{ b_id: bId, slots: res }]);
      handleCurrentSlot(res);
    } catch (error) {
      setApiLoading(false);
      console.error(error);
    }
  };

  const handleCurrentSlot = (slotData: any) => {
    const bookingCategory = bookingDetails.find((item: any) => item?.id == bId);
    if (bookingCategory?.typeId) {
      setHasExtras(bookingCategory?.hasExtras);
      setSlotsType(bookingCategory?.slotsType);
      setEXcludedDates(bookingCategory?.excludedDate);
      setMaxDays(bookingCategory?.maxDays);
      setApiLoading(false);
      setMenu(bookingCategory?.menuFile);
    }
  };

  useEffect(() => {
    if (!bookingDetails.length) return;
    let findIndex = bookingDetails.findIndex((item: any) => item?.id == bId);
    if (findIndex != -1) {
      setValue(findIndex);
    }
    const id = bId || bookingDetails[0]?.id;
    const foundSlot = slotsList.find((item: any) => item?.b_id === id);

    if (foundSlot) {
      handleCurrentSlot(foundSlot.slots);
    } else {
      getSlots(id);
    }
    if (getSeletedDateByUSer && slotsType == 1) {
      getBookingTime(id, getSeletedDateByUSer);
      setInitialMount(false);
    }

    if (getSeletedDateByUSer && slotsType == 2) {
      getBookingTime(id, getSeletedDateByUSer);
    } else if (getSeletedDateByUSer == null && slotsType == 2) {
      setTimes([]);
    }
  }, [bId, slotsList, getSeletedDateByUSer]);

  useEffect(() => {
    setBId(searchParams.get("bId"));
  }, [searchParams]);

  const renderedTabs = useMemo(
    () =>
      bookingDetails.map((item: any, index: number) => (
        <Tab
          key={index}
          id={item.id}
          label={get_lang(item.title, langValue)}
          onClick={() => handleClickTabs(item.id)}
          className="familysora600 text-capitalize"
          disabled={value === index}
        />
      )),
    [bookingDetails, langValue, value]
  );

  const renderedCategories = useMemo(
    () =>
      bookingDetails.map((item: any) => ({
        id: item.id,
        label: get_lang(item.title, langValue),
      })),
    [bookingDetails, langValue]
  );

  const renderSlots = () => {
    if (slotsType === 1) {
      return useNewUi ? (
        <GuestSlotsNew {...slotProps} />
      ) : (
        <GuestSlots {...slotProps} />
      );
    }
    if (slotsType === 2) {
      return useNewUi ? (
        <PackageSlotsNew {...slotProps} />
      ) : (
        <PackageSlots {...slotProps} />
      );
    }
    return useNewUi ? (
      <div className="checkBoxstep1__loading familysora400">Loading...</div>
    ) : (
      <>Loading......</>
    );
  };

  return (
    <>
      {routeLoading && <FreezScreen />}
      <div
        id="checkBoxstep1"
        className={useNewUi ? "checkBoxstep1--new-ui" : "checkBoxstep1--classic-ui"}
      >
        <CategoryBanner handleGoBack={handleGoBack} />
        <Steper
          label={t("Confirm date and time")}
          labelDecs={""}
          steps={true}
          stepNo={1}
          howMaysteps={hasExtras ? 3 : 2}
        />

        {useNewUi ? (
          renderedCategories.length > 1 && (
            <CategoryPills
              options={renderedCategories}
              selectedIndex={value}
              onSelect={(id) => handleClickTabs(String(id))}
              rtl={langValue === "ar"}
            />
          )
        ) : (
          <div className="mainTabs">
            <Tabs
              value={value}
              onChange={(e, newValue) => console.log(newValue)}
              variant="scrollable"
              scrollButtons={false}
              aria-label="disabled tabs example"
            >
              {renderedTabs}
            </Tabs>
          </div>
        )}

        {menu && (
          <div
            className={`w-100 d-flex align-items-center justify-content-center ${
              useNewUi ? "checkBoxstep1__menu-btn" : "show-classs"
            }`}
          >
            <Button
              variant="outlined"
              startIcon={<RestaurantMenuIcon />}
              onClick={() => window.open(menu, "_blank")}
            >
              {t(`Menu`)}
            </Button>
          </div>
        )}

        <div className={useNewUi ? "checkBoxstep1__slots" : undefined}>
          {renderSlots()}
        </div>
      </div>
    </>
  );
};

export default withTranslation()(CheckBoxstep1);
